import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetWageSupplementTypeConfigurations, AddWageSupplementTypeConfiguration, SaveWageSupplementTypeConfiguration, DeleteWageSupplementTypeConfiguration }

function GetWageSupplementTypeConfigurations(onSuccess, onError){
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/wagesupplementtypconfiguration`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function AddWageSupplementTypeConfiguration(
  wageSupplementTypeConfigurationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/wagesupplementtypconfiguration`,
        wageSupplementTypeConfigurationObject,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveWageSupplementTypeConfiguration(
  wageSupplementTypeConfigurationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/wagesupplementtypconfiguration`,
        wageSupplementTypeConfigurationObject,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteWageSupplementTypeConfiguration(
  wageSupplementTypeConfigurationId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/wagesupplementtypconfiguration/${wageSupplementTypeConfigurationId}`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
